import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useStaticQuery, graphql } from "gatsby";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const Container = styled.div`
  border-top: 4px solid #f1a857;
  border-bottom: 1px solid #ffffff;

  position: relative;

  .filter-results {
    font-size: 16px;
    color: #40403f;
    letter-spacing: 0.36px;
    font-weight: 600;
    padding-top: 24px;
    padding-bottom: 24px;
    width: 100%;
    background: transparent;

    display: flex;
    align-items: center;
    justify-content: center;

    i.icon-filter {
      display: none;
      width: 20px;
      height: 20px;
      margin-right: 7px;
      background: url(/images/streamline-icon-filter-1@140x140@2x-branco.png)
        no-repeat center;
      background-size: contain;
    }

    i.icon-arrow {
      background: url(/images/arrow-down.png) no-repeat center;
      background-size: contain;
      margin-left: 13px;
      width: 11px;
      height: 15px;
    }
    &.open {
      background: #f1a857;
      color: #fff;

      i.icon-filter {
        display: inline-block;
      }

      i.icon-arrow {
        background: url(/images/arrow-right.png) no-repeat center;
        width: 15px;
        transform: rotate(-90deg);
      }
    }
  }

  .filter-options.hidden-mobile {
    display: none;
  }

  .filter-options {
    position: absolute;
    top: calc(100% + 1px);
    width: 100%;

    box-shadow: 0 20px 30px 0px rgba(0, 0, 0, 0.5);
    background-color: #d8d8d8;
    z-index: 1;

    @media (max-width: 766px) {
      /* Keep touch scrolling inside the open filter panel on mobile Safari. */
      max-height: calc(100vh - 96px);
      max-height: calc(100dvh - 96px);
      overflow-y: auto;
      overscroll-behavior-y: contain;
      -webkit-overflow-scrolling: touch;
    }

    ul {
      & > li {
        border-bottom: 1px solid #ffffff;

        &.sub-open {
          .sub-item {
            display: flex;
          }

          .mobile-carousel {
            display: block;
          }
        }

        .header-title {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          padding-top: 25px;
          padding-bottom: 25px;

          > span {
            color: #40403f;
            font-size: 14px;
            letter-spacing: 0.32px;
            font-weight: 600;
          }

          .icon {
            width: 20px;
            height: 20px;
            display: inline-block;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            vertical-align: middle;
            &.icon-type {
              background-image: url(/images/streamline-icon-project-blueprint-create140x140.png);
            }
            &.icon-design {
              background-image: url(/images/streamline-icon-color-palette-sample-2@40x40@2x.png);
            }
            &.icon-mdf {
              background-image: url(/images/streamline-icon-layers-stacked-1@40x40@2x.png);
            }
            &.icon-hue {
              background-image: url(/images/streamline-icon-color-palette@40x40@2x.png);
            }
          }

          .icon-arrow {
            width: 11px;
            height: 15px;
            background: url(/images/arrow-down.png) no-repeat center;
            vertical-align: middle;
            margin-left: 15px;

            &.active-arrow {
              transform: rotate(180deg);
            }
          }
        }

        &:first-child,
        &:last-child {
          display: none;
        }

        .sub-item {
          padding-right: 20px;
          display: none;
          width: 100%;
          padding-bottom: 26px;
          overflow-x: auto;

          .container {
            padding: 0 20px;
            margin: 0 auto;
            column-count: 2;
            column-gap: 0;

            @media (min-width: 767px) {
              max-width: 767px;
              column-count: 3;
            }

            @media (min-width: 1200px) {
              max-width: 1200px;
              padding: 0 15px;
              column-count: 5;
            }
          }
        }

        .item {
          width: 100%;
          margin-bottom: 20px;
          color: #40403f;
          display: flex;
          align-items: center;
          cursor: pointer;
          break-inside: avoid;

          div {
            display: flex;
            align-items: center;
          }

          i {
            border: 2px solid #40403f;
            width: 20px;
            height: 20px;
            margin-right: 15px;
            display: inline-block;
            background: transparent;
            margin-left: 6px;
            appearance: none;
            border-radius: 3px;

            &.active {
              border: 2px solid #40403f;
              background: url(/images/check.svg) no-repeat center #40403f;
            }
          }
        }

        .box-option {
          border-bottom: 0;
          margin-right: 7px;
          min-width: 160px;
          max-width: 160px;
          height: 100px;
          border-radius: 3px;
          padding: 0;
          background-color: #9e9e9e;
          cursor: pointer;

          background-size: cover;
          background-position: center;

          div {
            padding: 10px 13px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            cursor: pointer;

            height: 100%;
            width: 100%;

            span {
              font: italic bold 20px "Times new roman";
              color: #ffffff;
            }

            i {
              border: 2px solid #ffffff;
              min-width: 20px;
              height: 20px;
              background: transparent;
              margin-left: 6px;
              appearance: none;
              border-radius: 3px;

              &.active {
                border: 2px solid #ffffff;
                background: url(/images/check.svg) no-repeat center #fff;
              }
            }
          }

          &:first-child {
            margin-left: 20px;
          }

          &:first-child,
          &:last-child {
            display: flex;
          }
        }

        .mobile-carousel {
          display: none;
          padding-bottom: 25px;

          ul.react-multi-carousel-track {
            padding-bottom: 35px;

            li {
              border-bottom: 0;

              .box-option {
                margin-right: 0;
                margin-left: 7px;
                max-width: 100%;
              }

              &:last-child,
              &:first-child {
                display: block;
              }
            }
          }

          ul.dots-carousel {
            li {
              border-bottom: 0;

              button {
                width: 8px;
                border: 1px solid #f1a857;
                height: 8px;
                background: transparent;
              }

              &.react-multi-carousel-dot--active button {
                background: #f1a857;
              }

              &:last-child,
              &:first-child {
                display: block;
              }
            }
          }
        }
      }
    }
  }

  @media (min-width: 767px) {
    .filter-results {
      display: none;
    }

    .filter-options.hidden-mobile {
      display: block;
    }

    .filter-options {
      position: relative;

      box-shadow: none;
      top: 0;

      ul {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        scrollbar-width: thin;

        max-width: 767px;
        width: 100%;
        padding: 0 20px;
        margin: 0 auto;

        li {
          border-right: 1px solid #e0e0e0;
          border-bottom: 0;
          flex: 0 0 auto;
          min-width: auto;

          .header-title {
            color: #40403f;
            font-size: 13px;
            letter-spacing: 0.32px;
            font-weight: 600;
            cursor: pointer;

            width: auto;
            padding: 0 16px;
            height: 60px;
            justify-content: center;
            align-items: center;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            gap: 8px;
            white-space: nowrap;
            overflow: hidden;

            > span {
              text-align: center;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              min-width: 0;
            }

            .icon-arrow {
              display: inline-block;
              margin-left: 0;
              margin-top: 0;
              flex-shrink: 0;

              &.active-arrow {
                transform: rotate(180deg);
              }
            }

            .icon {
              display: inline-block;
              margin-bottom: 0;
              flex-shrink: 0;
            }
          }

          &:first-child,
          &:last-child {
            display: flex;
          }

          &:last-child {
            border-right: 0;
            padding-right: 0;
            padding-left: 0;
            justify-content: flex-end;
            margin-left: auto;

            a {
              cursor: pointer;
              color: #40403f;
              font-size: 14px;
              letter-spacing: 0.32px;
              font-weight: 600;
              padding-right: 15px;
              padding-left: 15px;

              background: transparent;

              display: flex;
              align-items: center;
              text-align: left;
              justify-content: flex-end;

              height: 60px;
              width: 100%;

              span {
                width: 60px;
              }

              i {
                width: 20px;
                height: 20px;
                display: inline-block;
                background: url(/images/streamline-icon-keyboard-arrow-return@40x40@2x.png)
                  no-repeat center;
                background-size: contain;
                margin-right: 12px;
              }

              &:hover {
                background: #fff;
              }
            }
          }

          &:first-child {
            padding-left: 0;
            max-width: 90px;
            padding-right: 20px;
            height: 60px;
            align-items: center;

            color: #40403f;
            font-size: 14px;
            letter-spacing: 0.32px;
            font-weight: 400;
          }

          position: static;

          &.sub-open {
            .header-title {
              background: #ffffff;
            }

            .sub-item {
              display: flex;
            }
          }

          .sub-item {
            display: none;
            position: absolute;
            background: #e9e9e9;
            width: 100%;
            max-width: none;
            padding: 20px calc(50% - 767px / 2 + 20px);

            top: calc(100% + 1px);
            left: 0;
            right: 0;
            transform: none;
            margin: 0;
            z-index: 10;

            flex-wrap: wrap;
            gap: 7px;
            overflow: visible;

            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);

            &.mdf {
              .container {
                width: 100%;
                padding: 0;
              }

              .item {
                margin-bottom: 18px;
              }
            }

            .box-option {
              min-width: 160px;
              max-width: 160px;
              width: 160px;
              height: 100px;
              margin: 0;
              border-radius: 3px;
              border-bottom: 0;

              &:first-child,
              &:last-child {
                display: flex;
              }
            }

            .fechar-filtro {
              flex: 0 0 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 14px;
              height: 60px;
              cursor: pointer;
              /* cancel the panel padding so the bar spans full width, flush to the bottom edge */
              margin: 20px calc(-50% + 767px / 2 - 20px) -20px;
              background: #e0e0e0;
              transition: background 0.2s ease;

              span {
                color: #40403f;
                font-size: 14px;
                font-weight: 600;
                letter-spacing: 0.32px;
                text-transform: uppercase;
              }

              i {
                width: 15px;
                height: 11px;
                background-color: #f1a857;
                -webkit-mask: url(/images/arrow-right.png) no-repeat center;
                mask: url(/images/arrow-right.png) no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
                transform: rotate(-90deg);
              }

              &:hover {
                background: #fff;
              }
            }
          }

          .box-option {
            &:hover {
              opacity: 0.8;
            }
          }
        }

        &::-webkit-scrollbar {
          height: 8px;
        }

        &::-webkit-scrollbar-track {
          background: #d8d8d8;
        }

        &::-webkit-scrollbar-thumb {
          background: #b9b9b9;
          border-radius: 4px;
        }
      }
    }
  }

  @media (min-width: 1200px) {
    .filter-options {
      ul {
        max-width: 1200px;
        padding: 0 15px;
        justify-content: flex-start;

        li {
          flex: 1;
          max-width: inherit;

          .header-title {
            padding: 0 8px;
            font-size: 13px;

            > span {
              font-size: 13px;
            }
          }

          &:first-child {
            flex: 0 0 auto;
            max-width: 130px;
            padding-right: 15px;
            justify-content: flex-start;
          }

          &:last-child {
            flex: 0 0 auto;
            a span {
              width: 58px;
            }
          }

          .sub-item.mdf {
            .item {
              width: 100%;
            }
          }

          .sub-item {
            padding: 20px calc(50% - 1200px / 2 + 15px);

            .fechar-filtro {
              margin: 20px calc(-50% + 1200px / 2 - 15px) -20px;
            }
          }
        }
      }
    }
  }
`;

const carouselResponsive = {
  desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3, partialVisibilityGutter: 40 },
  tablet: { breakpoint: { max: 1024, min: 464 }, items: 2, partialVisibilityGutter: 30 },
  mobile: { breakpoint: { max: 464, min: 0 }, items: 2, partialVisibilityGutter: 10 },
};

export default function FilterProjects(props) {
  const { onFilterChange } = props;

  const results = useStaticQuery(graphql`
    {
      tipo_projeto: allPrismicTipoDeProjeto(
        sort: { fields: data___titulo___text, order: ASC }
      ) {
        edges {
          node {
            data {
              imagem { url }
              titulo { text }
            }
            uid
          }
        }
      }
      tonalidade_produto: allPrismicTonalidadeProduto(
        filter: { lang: { eq: "pt-br" } }
        sort: { fields: data___nome___text, order: ASC }
      ) {
        edges {
          node {
            data {
              imagem { url }
              nome { text }
            }
            uid
          }
        }
      }
      design_do_produto: allPrismicDesignDoProduto(
        filter: { lang: { eq: "pt-br" } }
        sort: { fields: data___nome___text, order: ASC }
      ) {
        edges {
          node {
            data {
              imagem { url }
              nome { text }
            }
            uid
          }
        }
      }
      linha_produto: allPrismicCategoriaProdutos(
        sort: { fields: data___nome___text, order: ASC }
        filter: { lang: { eq: "pt-br" } }
      ) {
        edges {
          node {
            data {
              nome { text }
              imagem { url }
            }
            uid
          }
        }
      }
      mdf: allPrismicProduto(
        sort: { fields: data___nome___text, order: ASC }
        filter: {
          data: {
            tipos_de_produtos: {
              elemMatch: {
                tipo_de_produto1: { slug: { in: ["revestidos", "aris"] } }
              }
            }
          }
          lang: { eq: "pt-br" }
        }
      ) {
        edges {
          node {
            data {
              imagem_principal { url }
              nome { text }
            }
            uid
          }
        }
      }
    }
  `);

  const { design_do_produto, mdf, tonalidade_produto, tipo_projeto, linha_produto } = results;

  const sortedTipo = [...tipo_projeto.edges].sort((a, b) =>
    a.node.data.titulo.text.localeCompare(b.node.data.titulo.text, "pt")
  );
  const sortedTonalidade = [...tonalidade_produto.edges].sort((a, b) =>
    a.node.data.nome[0].text.localeCompare(b.node.data.nome[0].text, "pt")
  );
  const sortedDesign = [...design_do_produto.edges].sort((a, b) =>
    a.node.data.nome.text.localeCompare(b.node.data.nome.text, "pt")
  );

  const [openResultsMobile, setOpenResultsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth > 767 : true
  );
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 767 : false
  );
  const [openFilter, setOpenFilter] = useState(null);
  const filterOptionsRef = useRef(null);

  const [filters, setFilters] = useState({
    tipo: props.tipo || "",
    design: props.design || "",
    tonalidade: props.tonalidade || "",
    mdf: props.mdfFilter || "",
    linha: props.linha || "",
    is3d: props.is3d || "",
  });

  function toggleFilter(name) {
    setOpenFilter((prev) => (prev === name ? null : name));
  }

  function toggleValue(paramName, currentValue, newValue) {
    const current = currentValue ? currentValue.split(",").filter(Boolean) : [];
    const next =
      current.indexOf(newValue) === -1
        ? [...current, newValue]
        : current.filter((v) => v !== newValue);
    return next.join(",");
  }

  function applyFilter(paramName, newValue) {
    const updated = { ...filters, [paramName]: newValue };
    setFilters(updated);

    const params = new URLSearchParams({
      "tipo-de-projeto": updated.tipo,
      design: updated.design,
      mdf: updated.mdf,
      tonalidade: updated.tonalidade,
      linha: updated.linha,
      is_3d: updated.is3d,
    });
    window.history.pushState({}, "", `/ambientes/?${params.toString()}`);

    if (onFilterChange) onFilterChange(updated);
  }

  function clearFilters() {
    const cleared = { tipo: "", design: "", tonalidade: "", mdf: "", linha: "", is3d: "" };
    setFilters(cleared);
    window.history.pushState({}, "", `/ambientes/?tipo-de-projeto=&design=&mdf=&tonalidade=&linha=&is_3d=`);
    if (onFilterChange) onFilterChange(cleared);
  }

  function isSelected(currentValue, value) {
    if (!currentValue) return false;
    return currentValue.split(",").filter(Boolean).indexOf(value) !== -1;
  }

  function isOpen(name) {
    return openFilter === name;
  }

  function toggleMobileResults() {
    setOpenResultsMobile((prev) => !prev);
  }

  const resize = () => {
    if (document.body.clientWidth > 767) {
      setOpenResultsMobile(true);
      setOpenFilter(null);
    } else {
      setOpenResultsMobile(false);
    }
  };

  const resizeCarousel = () => {
    setIsMobile(document.body.clientWidth < 767);
  };

  useEffect(() => {
    function handlePointerDown(e) {
      if (filterOptionsRef.current && !filterOptionsRef.current.contains(e.target)) {
        setOpenFilter(null);
      }
    }
    document.addEventListener("pointerdown", handlePointerDown);
    return () => document.removeEventListener("pointerdown", handlePointerDown);
  }, []);

  useEffect(() => {
    resize();
    resizeCarousel();
    window.addEventListener("resize", resize);
    window.addEventListener("resize", resizeCarousel);
    return () => {
      window.removeEventListener("resize", resize);
      window.removeEventListener("resize", resizeCarousel);
    };
  }, []);

  const hasActiveFilters =
    filters.mdf.length > 0 ||
    filters.tipo.length > 0 ||
    filters.tonalidade.length > 0 ||
    filters.design.length > 0 ||
    filters.linha.length > 0 ||
    filters.is3d.length > 0;

  // ponytail: one element reused in every desktop sub-item; visible only when its panel is open (sub-item is display:none until .sub-open)
  const closeBar = (
    <div className="fechar-filtro" onClick={() => setOpenFilter(null)}>
      <span>Fechar Filtro</span>
      <i></i>
    </div>
  );

  return (
    <Container>
      <button
        className={`${openResultsMobile ? "filter-results open" : "filter-results"}`}
        onClick={toggleMobileResults}
      >
        <i className="icon-filter"></i>
        <span>{openResultsMobile ? "Filtrar resultados" : "Filtrar projetos"}</span>
        <i className="icon-arrow"></i>
      </button>

      <div
        ref={filterOptionsRef}
        className={`filter-options${openResultsMobile ? "" : " hidden-mobile"}`}
      >
        <ul>
          <li>Filtrar por:</li>

          {/* Tipo de ambiente */}
          <li className={isOpen("type") ? "sub-open" : ""}>
            <div className="header-title" onClick={() => toggleFilter("type")}>
              <i className="icon icon-type"></i>
              <span>Tipo de ambiente</span>
              <i className={isOpen("type") ? "icon-arrow active-arrow" : "icon-arrow"}></i>
            </div>
            {isMobile ? (
              isOpen("type") && (
                <div className="mobile-carousel">
                  <Carousel additionalTransfrom={0} arrows={false} showDots dotListClass="dots-carousel" centerMode={false} className="" containerClass="container-carousel" draggable focusOnSelect={false} minimumTouchDrag={80} partialVisible renderButtonGroupOutside={false} renderDotsOutside={false} responsive={carouselResponsive} slidesToSlide={2} swipeable>
                    {sortedTipo.map((item, index) => (
                      <div key={index} className="box-option" style={item.node.data.imagem ? { backgroundImage: `url('${item.node.data.imagem.url}')` } : null} onClick={() => applyFilter("tipo", toggleValue("tipo", filters.tipo, item.node.data.titulo.text))}>
                        <div>
                          <span>{item.node.data.titulo.text}</span>
                          <i className={isSelected(filters.tipo, item.node.data.titulo.text) ? "active" : ""}></i>
                        </div>
                      </div>
                    ))}
                  </Carousel>
                </div>
              )
            ) : (
              <div className="sub-item">
                {sortedTipo.map((item, index) => (
                  <div key={index} className="box-option" style={item.node.data.imagem ? { backgroundImage: `url('${item.node.data.imagem.url}')` } : null} onClick={() => applyFilter("tipo", toggleValue("tipo", filters.tipo, item.node.data.titulo.text))}>
                    <div>
                      <span>{item.node.data.titulo.text}</span>
                      <i className={isSelected(filters.tipo, item.node.data.titulo.text) ? "active" : ""}></i>
                    </div>
                  </div>
                ))}
                {closeBar}
              </div>
            )}
          </li>

          {/* MDF Utilizado */}
          <li className={isOpen("mdf") ? "sub-open" : ""}>
            <div className="header-title" onClick={() => toggleFilter("mdf")}>
              <i className="icon icon-mdf"></i>
              <span>MDF Utilizado</span>
              <i className={isOpen("mdf") ? "icon-arrow active-arrow" : "icon-arrow"}></i>
            </div>
            <div className="sub-item mdf">
              <div className="container">
                {mdf.edges.map((item, index) => (
                  <div key={index} className="item" onClick={() => applyFilter("mdf", toggleValue("mdf", filters.mdf, item.node.data.nome[0].text))}>
                    <div>
                      <i className={isSelected(filters.mdf, item.node.data.nome[0].text) ? "active" : ""}></i>
                      <span>{item.node.data.nome[0].text}</span>
                    </div>
                  </div>
                ))}
              </div>
              {closeBar}
            </div>
          </li>

          {/* Linha de Produto */}
          <li className={isOpen("linha") ? "sub-open" : ""}>
            <div className="header-title" onClick={() => toggleFilter("linha")}>
              <i className="icon icon-mdf"></i>
              <span>Linha de Produto</span>
              <i className={isOpen("linha") ? "icon-arrow active-arrow" : "icon-arrow"}></i>
            </div>
            {isMobile ? (
              isOpen("linha") && (
                <div className="mobile-carousel">
                  <Carousel additionalTransfrom={0} arrows={false} showDots dotListClass="dots-carousel" centerMode={false} className="" containerClass="container-carousel" draggable focusOnSelect={false} minimumTouchDrag={80} partialVisible renderButtonGroupOutside={false} renderDotsOutside={false} responsive={carouselResponsive} slidesToSlide={2} swipeable>
                    {linha_produto.edges.map((item, index) => (
                      <div key={index} className="box-option" style={item.node.data.imagem && item.node.data.imagem.url ? { backgroundImage: `url('${item.node.data.imagem.url}')` } : null} onClick={() => applyFilter("linha", toggleValue("linha", filters.linha, item.node.uid))}>
                        <div>
                          <span>{item.node.data.nome[0].text}</span>
                          <i className={isSelected(filters.linha, item.node.uid) ? "active" : ""}></i>
                        </div>
                      </div>
                    ))}
                  </Carousel>
                </div>
              )
            ) : (
              <div className="sub-item">
                {linha_produto.edges.map((item, index) => (
                  <div key={index} className="box-option" style={item.node.data.imagem && item.node.data.imagem.url ? { backgroundImage: `url('${item.node.data.imagem.url}')` } : null} onClick={() => applyFilter("linha", toggleValue("linha", filters.linha, item.node.uid))}>
                    <div>
                      <span>{item.node.data.nome[0].text}</span>
                      <i className={isSelected(filters.linha, item.node.uid) ? "active" : ""}></i>
                    </div>
                  </div>
                ))}
                {closeBar}
              </div>
            )}
          </li>

          {/* Tonalidade */}
          <li className={isOpen("tonalidade") ? "sub-open" : ""}>
            <div className="header-title" onClick={() => toggleFilter("tonalidade")}>
              <i className="icon icon-hue"></i>
              <span>Tonalidade</span>
              <i className={isOpen("tonalidade") ? "icon-arrow active-arrow" : "icon-arrow"}></i>
            </div>
            {isMobile ? (
              isOpen("tonalidade") && (
                <div className="mobile-carousel">
                  <Carousel additionalTransfrom={0} arrows={false} showDots dotListClass="dots-carousel" centerMode={false} className="" containerClass="container-carousel" draggable focusOnSelect={false} minimumTouchDrag={80} partialVisible renderButtonGroupOutside={false} renderDotsOutside={false} responsive={carouselResponsive} slidesToSlide={2} swipeable>
                    {sortedTonalidade.map((item, index) => (
                      <div key={index} className="box-option" style={item.node.data.imagem.url ? { backgroundImage: `url('${item.node.data.imagem.url}')` } : null} onClick={() => applyFilter("tonalidade", toggleValue("tonalidade", filters.tonalidade, item.node.uid))}>
                        <div>
                          <span>{item.node.data.nome[0].text}</span>
                          <i className={isSelected(filters.tonalidade, item.node.uid) ? "active" : ""}></i>
                        </div>
                      </div>
                    ))}
                  </Carousel>
                </div>
              )
            ) : (
              <div className="sub-item">
                {sortedTonalidade.map((item, index) => (
                  <div key={index} className="box-option" style={item.node.data.imagem.url ? { backgroundImage: `url('${item.node.data.imagem.url}')` } : null} onClick={() => applyFilter("tonalidade", toggleValue("tonalidade", filters.tonalidade, item.node.uid))}>
                    <div>
                      <span>{item.node.data.nome[0].text}</span>
                      <i className={isSelected(filters.tonalidade, item.node.uid) ? "active" : ""}></i>
                    </div>
                  </div>
                ))}
                {closeBar}
              </div>
            )}
          </li>

          {/* Design do material */}
          <li className={isOpen("design") ? "sub-open" : ""}>
            <div className="header-title" onClick={() => toggleFilter("design")}>
              <i className="icon icon-design"></i>
              <span>Design do material</span>
              <i className={isOpen("design") ? "icon-arrow active-arrow" : "icon-arrow"}></i>
            </div>
            {isMobile ? (
              isOpen("design") && (
                <div className="mobile-carousel">
                  <Carousel additionalTransfrom={0} arrows={false} showDots dotListClass="dots-carousel" centerMode={false} className="" containerClass="container-carousel" draggable focusOnSelect={false} minimumTouchDrag={80} partialVisible renderButtonGroupOutside={false} renderDotsOutside={false} responsive={carouselResponsive} slidesToSlide={2} swipeable>
                    {sortedDesign.map((item, index) => (
                      <div key={index} className="box-option" style={item.node.data.imagem.url ? { backgroundImage: `url('${item.node.data.imagem.url}')` } : null} onClick={() => applyFilter("design", toggleValue("design", filters.design, item.node.uid))}>
                        <div>
                          <span>{item.node.data.nome.text}</span>
                          <i className={isSelected(filters.design, item.node.uid) ? "active" : ""}></i>
                        </div>
                      </div>
                    ))}
                  </Carousel>
                </div>
              )
            ) : (
              <div className="sub-item">
                {sortedDesign.map((item, index) => (
                  <div key={index} className="box-option" style={item.node.data.imagem ? { backgroundImage: `url('${item.node.data.imagem.url}')` } : null} onClick={() => applyFilter("design", toggleValue("design", filters.design, item.node.uid))}>
                    <div>
                      <span>{item.node.data.nome.text}</span>
                      <i className={isSelected(filters.design, item.node.uid) ? "active" : ""}></i>
                    </div>
                  </div>
                ))}
                {closeBar}
              </div>
            )}
          </li>

          {/* Tipo de Imagem */}
          <li className={isOpen("is3d") ? "sub-open" : ""}>
            <div className="header-title" onClick={() => toggleFilter("is3d")}>
              <i className="icon icon-mdf"></i>
              <span>Tipo de Imagem</span>
              <i className={isOpen("is3d") || filters.is3d.length > 0 ? "icon-arrow active-arrow" : "icon-arrow"}></i>
            </div>
            <div className="sub-item">
              <div
                className="box-option"
                style={{ backgroundImage: `url('https://images.prismic.io/guararapes/43b992b7-00b6-47a3-8bb8-f54e8855cbbc_quartos_infantis.jpg?auto=compress%2Cformat&fit=max&q=50')` }}
                onClick={() => applyFilter("is3d", filters.is3d === "0" ? "" : "0")}
              >
                <div>
                  <span>Imagens Reais</span>
                  <i className={filters.is3d === "0" ? "active" : ""}></i>
                </div>
              </div>
              <div
                className="box-option"
                style={{ backgroundImage: `url('https://images.prismic.io/guararapes/98c51083-830e-415e-8c07-7b55b11f016f_cozinhas.jpg?auto=compress%2Cformat&fit=max&q=50')` }}
                onClick={() => applyFilter("is3d", filters.is3d === "1" ? "" : "1")}
              >
                <div>
                  <span>Imagens 3D</span>
                  <i className={filters.is3d === "1" ? "active" : ""}></i>
                </div>
              </div>
              {closeBar}
            </div>
          </li>

          {/* Limpar */}
          <li>
            {hasActiveFilters && (
              <a href="#" onClick={(e) => { e.preventDefault(); clearFilters(); }}>
                <i></i>
                <span>Limpar</span>
              </a>
            )}
          </li>
        </ul>
      </div>
    </Container>
  );
}
